<template>
    <div class="wrapper">
        <div class="page-header page-header-big">
            <parallax class="page-header-image" style="background-image: url('img/papiry_1.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h4>Komplexní služby v oblasti odpadového hospodářství.</h4>
                        <h1 class="title">KE STAŽENÍ</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator-line separator-primary"></div>

        <div class="row">
            <div class="col-1"></div>
            <div class="col-xs-10 col-md-5 ml-auto mr-auto">
                <div class="card text-center pruhledna">
                    <div class="card-header mt-2">
                    </div>
                    <div class="card-body">
                        <div class="about-contact">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-8 mr-auto ml-auto">
                                        <h4 class="text-left stazeni"><a href="/img/kopie_zl_no.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> Kopie živnostenského listu NO</a></h4>
                                        <h4 class="text-left"></h4>
                                        <h4 class="text-left stazeni"><a href="/img/kopie_zl_oo.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> Kopie živnostenského listu OO</a></h4>
                                        <h4 class="text-left"></h4>
                                        <h4 class="text-left stazeni"><a href="/img/ruk_ippc.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> Úplné znění IPPC</a></h4>
                                        <h4 class="text-left"></h4>
                                        <h4 class="text-left stazeni"><a href="/img/pr_so.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> Provozní řád - seznam odpadů</a></h4>
                                        <h4 class="text-left"></h4>
                                        <h4 class="text-left stazeni"><a href="/img/osvedceni_cu.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> Rozhodnutí CÚ o spotřební dani</a></h4>
                                        <h4 class="text-left"></h4>
                                        <h4 class="text-left stazeni"><a href="/img/imgdpr.pdf" target="_new" class="no_line"><img src="/img/attach_file.svg" alt=""> 	Inform. memorandum GDPR</a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-muted mb-2">
                    </div>
                </div>
            </div> 

            <div class="col-xs-10 col-md-5 ml-auto mr-auto">
                <div class="card text-center pruhledna">
                    <div class="card-header mt-2">
                    </div>
                    <div class="card-body">
                        <div class="about-contact">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-8 mr-auto ml-auto">
                                        <h4 class="text-center stazeni"><a href="/img/ISO_9001.pdf" target="_new" class="no_line"><img src="/img/ico_qms.jpg" alt=""> ISO 9001</a></h4>
                                        <h4 class="text-center"></h4>
                                        <h4 class="text-center stazeni"><a href="/img/ISO_14001.pdf" target="_new" class="no_line"><img src="/img/ico_ems.jpg" alt=""> ISO 14001</a></h4>
                                    </div>
                                </div>

                                <div class="separator-line separator-primary"></div>

                                <div class="row">
                                    <div class="col-md-8 mr-auto ml-auto">
                                        <h4 class="text-center stazeni"><a href="http://www.inisoft.cz/" target="_new" class="no_line"><img src="/img/inisoft1.jpg" alt=""></a></h4>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-muted mb-2">
                    </div>
                </div>

            </div>    
            <div class="col-1"></div>
        </div>

        <div class="separator-line separator-primary"></div>


    </div>
</template>
<script>
  import { Button, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'stahnout',
    bodyClass: 'stahnout',
    components: {
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: ''
        },
        imgSrc: "img/card_8145342.jpg"
      }
    }
  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}        
.features-3 {
    padding: 0 0 !important;
}        
.description {
    color: #888 !important;
    font-weight: 500 !important;
}       
.maxtitle {
    color: white !important;
    font-size: 50px !important;
    font-weight: 900 !important;
    padding-top: 0px !important;
}    
.vytahnout {
    margin-top: -8vh;
}    

.pruhledna {
    opacity: 0.9;
}

.page-header, .page-header-small {
    min-height: 40vh !important;
    max-height: 300px;
}    

.maxtitle1 {
    padding-top: 60px !important;
}  

.page-header {
    min-height: 60vh !important;
}  

.stazeni {
    font-size: 14px !important;
    color: orange !important;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}  

.no-line:hover, .no-line:active {
    border-bottom: 0px !important;
}  


</style>
